import { scooterAction } from "./action"

export const initialState = {
  totalAmount: 0,
  stepMenu: [],
  currentModel: null,
  currentColor: null,
  accessoryGroup: [],
  allAccessory: [],
  comboAccessory: [],
  currentStep: 0,
  subsidyData: {
    subsidyType: 0,
    subsidyUnit: 0,
    subsidyCounty: 0,
    subsidyCountyName: "",
    localSubsidySelected: [],
    localSubsidyName: "",
    localSubsidyType: 0,
  },
  licensedData: {
    LicensingSiteId: "DMV_NTP", // 新北市領牌中心
    LicensingState: 1,
    InsuranceYear: 2,
    SealType: 1,
    agencyFees: 2050,
  },
  paymentMethod: {
    type: 0,
    index: 0,
    company: 0,
    period: 6,
    periodAmount: 0,
    per: 0,
  },
  selectedStore: {
    area: "北",
    storeName: null,
  },
  selectedAuthorizeCenter: {
    area: undefined,
    authorizeCenterName: null,
  },
  contactData: {
    customerName: null,
    customerPhone: null,
    customerEmail: null,
    directStore: null,
    businessName: null,
    businessEmail: null,
    businessLine: null,
    businessPhone: null,
    agreeForPrivacy: false,
    authorizeName: null,
    authorizePhone: null,
    authorizeEmail: null,
  },
  vin: undefined,
  colorCode: undefined,
}

export function scooterReducer(state = initialState, action) {
  switch (action.type) {
    case scooterAction.SET_SCOOTER_STATE: {
      return Object.assign({}, state, action.payload)
    }

    case scooterAction.SET_VIN: {
      return {
        ...state,
        vin: action.payload,
      }
    }

    case scooterAction.SET_QUERY_LOCAL_SUBSIDY_PAYLOAD: {
      return {
        ...state,
        queryLocalSubsidyPayload: action.payload,
      }
    }

    case scooterAction.SET_COLOR_CODE: {
      return {
        ...state,
        colorCode: action.payload,
      }
    }

    default:
      return state
  }
}
